import { render, staticRenderFns } from "./selectTipoLigacao.vue?vue&type=template&id=536e5add&scoped=true"
import script from "./selectTipoLigacao.vue?vue&type=script&lang=js"
export * from "./selectTipoLigacao.vue?vue&type=script&lang=js"
import style0 from "./selectTipoLigacao.vue?vue&type=style&index=0&id=536e5add&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536e5add",
  null
  
)

export default component.exports